<script setup lang="ts">
import SearchField from '@/components/filter/SearchField.vue';
import { I18nKey } from '@/utils/typings';
import { SetupParameterOverviewFilterObject } from './types';

const modelValue = defineModel<SetupParameterOverviewFilterObject>({
  required: true,
});

const searchedFieldsI18nKeys: I18nKey[] = ['Search'];
</script>

<template>
  <SearchField
    v-model="modelValue.search"
    width="15em"
    :placeholder="
      $t('SearchPlaceholder', {
        columns: searchedFieldsI18nKeys.map((key) => `$t(${key})`),
      })
    "
  />
</template>
